import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const LoadMoreReferences = (props) => {

  let text_show = 'Toon meer recensies'
  let text_showing = `${props.nrShowing} van de ${props.nrAll} getoond`

  if (props.language == 'en') {
    text_show = 'Show more reviews'
    text_showing = `${props.nrShowing} of ${props.nrAll} showing`
  }

  function handleLoadMore(e) {
    e.preventDefault()
    props.onLoadMore()
  }

  if (props.loading) {
    return null
    // we already return a loader in Projects.js
  }

  if (props.nrShowing >= props.nrAll) {
    return null
    // we have loaded all posts
  }

  return (
    <div className="c-references-load-more">
      <a href="#" onClick={handleLoadMore} className="c-references-load-more__link">

        <div className="c-references-load-more__title">
          {text_show}
        </div>

        <div className="c-references-load-more__subtitle">{text_showing}</div>
      </a>
    </div>
  )
}

export default LoadMoreReferences



// WEBPACK FOOTER //
// ./src/js/references/components/LoadMoreReferences.js
